import { render, staticRenderFns } from "./Detaileds.vue?vue&type=template&id=cc126054"
import script from "./Detaileds.vue?vue&type=script&lang=js"
export * from "./Detaileds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports